import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as types from "@/store/constants/types";

var Getters = _defineProperty({}, types.GETTER_TEMP_RESULT_BY_NAME, function (state) {
  return function (payLoad) {
    return state[payLoad];
  };
});

export default Getters;